export default "__VITE_ASSET__CMwY3tQC__"